export enum PickupStatus {
  STATUS_VOID = -2,
  STATUS_CANCEL = -1,
  STATUS_PENDING = 0,
  STATUS_SUCCESS = 1,
}
